import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import customParseFormat from "dayjs/plugin/customParseFormat";

import "dayjs/locale/en";
import "dayjs/locale/it";
import "dayjs/locale/pt";
import "dayjs/locale/es";
import "dayjs/locale/fr";

dayjs.extend(localeData);
dayjs.extend(customParseFormat);

export default {
    install(Vue) {
        const initialState = JSON.parse(
            localStorage.getItem("@datadrive:initialState")
        );
        const domainData = JSON.parse(
            localStorage.getItem("@datadrive:domain")
        );
        let lang = "pt";

        if (initialState) {
            lang = initialState.languageCode;
        } else if (domainData) {
            lang = domainData.languageCode;
        }

        dayjs.locale(lang);

        Vue.prototype.$dayjs = dayjs;

        Vue.mixin({
            methods: {
                setDayjsLocale(locale) {
                    dayjs.locale(locale);
                },
            },
        });
    },
};
